import {
  mutationOptions,
  useMutation,
  type UseMutationOptions,
} from '@tanstack/react-query';

import { evaluateOcrModelPerformance } from './evaluateOcrModelPerformance';
import {
  type EvaluateOcrModelPerformancePayload,
  type EvaluateOcrModelPerformanceResponse,
} from './types';

export const getEvaluateOcrModelPerformanceMutationOptions = ({
  options,
}: {
  options?: Omit<UseMutationOptions, 'mutationFn'>;
}): UseMutationOptions =>
  mutationOptions({
    mutationFn: async (queryParameters: EvaluateOcrModelPerformancePayload) =>
      evaluateOcrModelPerformance(queryParameters),
    ...options,
  });

/**
 * Custom useMutation hook to evaluate OCR model performance on randomly selected PDFs.
 * @param options - Mutation options
 * @param queryParameters - Query parameters
 * @returns The evaluation result.
 * @see https://ai.vestigas.com/redoc#operation/evaluate_evaluate_get
 */
export const useMutationEvaluateOcrModelPerformance = (
  options?: Omit<
    UseMutationOptions<EvaluateOcrModelPerformanceResponse>,
    'mutationFn'
  >,
) => {
  return useMutation({
    ...getEvaluateOcrModelPerformanceMutationOptions({
      options,
    }),
  });
};
